import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query ProviderSettings($platform: Platform) {
    providerSettings(platform: $platform) {
      iosSettings {
        applePayId
        iosReturnUrl
      }
      androidSettings {
        googlePayId
      }
    }
  }
`

export const toString = query.loc.source.body

export const providerSettingsKey = getQueryNames(query)[0]

export default query
